<route>
{
  "meta": {
    "auth": "WriteOffRecords"
  }
}
</route>

<template>
  <div>
    <el-card class="searchContainer">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="8">
          <div class="detail">
            <div>
              <span class="intro">商家ID:</span>
              <span> {{ vendorDetail.businessId }}</span>
            </div>
            <div>
              <span class="intro">已核销金额：</span>
              <span> {{ vendorDetail.checkNoMoney }}</span>
            </div>
            <div>
              <span class="intro">待核销金额：</span>
              <span> {{ vendorDetail.checkOffMoney }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="detail">
            <div>
              <span class="intro">商家昵称：</span>
              <span> {{ vendorDetail.businessName }}</span>
            </div>
            <div>
              <span class="intro">已核销笔数：</span>
              <span> {{ vendorDetail.checkNoCount }}</span>
            </div>
            <div>
              <span class="intro">待核销笔数：</span>
              <span> {{ vendorDetail.checkOffCount }}</span>
            </div>
          </div>
        </el-col>
      </el-row></el-card
    >
    <el-card class="tableContainer">
      <div slot="header" class="clearfix">
        <span>数据列表</span>
      </div>

      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column align="center" prop="storeName" label="核销门店"> </el-table-column>
        <el-table-column align="center" prop="settleMoney" label="已核销金额"> </el-table-column>
        <el-table-column align="center" prop="skuCount" label="核销码数"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="check(scope.row)" type="text" size="small"> 核销明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { pagination } from '@/mixin/pagination'
export default {
  mixins: [pagination],

  data() {
    return {
      searchValue: '',
      list: [],
      vendorDetail: {}
    }
  },
  methods: {
    getList(val) {
      this.loading = true
      this.currentPage = val === true ? this.currentPage : 1
      let params = {
        params: {
          page: this.currentPage,
          size: this.pageSize
        }
      }
      this.$api.financial
        .financial('getCheckRecordList', params, this.$route.query.id)
        .then(res => {
          this.vendorDetail = res
          this.list = res.checkCodeRecords.records
          this.total = parseInt(res.checkCodeRecords.total)
        })
        .catch(err => {
          this.$message.error(err.msg || '操作失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    check(row) {
      this.$router.push({
        path: '/financial/vendor/writeoffDetail',
        query: {
          id: row.storeId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.query {
  margin-top: 20px;
}

.detail {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  div {
    line-height: 30px;

    .intro {
      display: inline-block;
      width: 100px;
      color: #999;
    }
  }
}
</style>
